import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function Navigation() {
  const { user, logout } = useAuth();
  const location = useLocation();

  const linkClass = (path) => `nav-link${location.pathname === path ? ' active' : ''}`;

  return (
    <nav className="navbar">
      <div className="navbar-content">
        <h1>AvtoRadar</h1>
        <div className="nav-links">
          <Link to="/" className={linkClass('/')}>Avtomobili</Link>
          <Link to="/v-okvari" className={linkClass('/v-okvari')}>V okvari</Link>
          <Link to="/prvi-lastnik" className={linkClass('/prvi-lastnik')}>1. lastnik</Link>
          {(user?.role === 'ADMIN' || user?.gebrauchtwagenEnabled) && <Link to="/gebrauchtwagen" className={linkClass('/gebrauchtwagen')}>Gebrauchtwagen</Link>}
          <Link to="/sms" className={linkClass('/sms')}>SMS plošča</Link>
          {user?.role === 'ADMIN' && <Link to="/admin" className={linkClass('/admin')}>Administracija</Link>}
          {user?.role === 'ADMIN' && <Link to="/dealers" className={linkClass('/dealers')}>Avtohiše</Link>}
          <span className="nav-user">Uporabnik: {user?.username}</span>
          <button onClick={logout}>Odjava</button>
        </div>
      </div>
    </nav>
  );
}

export default Navigation;